import { registerLocaleData } from '@angular/common';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import localeSwedish from '@angular/common/locales/sv';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { BreadcrumbService } from './layout/service/app.breadcrumb.service';
import { AppCodeModule } from './app.code.component';
import { AppComponent } from './app.component';
import { AppConfig } from './app.config';
import { AppConfigComponent } from './app.config.component';
import { AppFooterComponent } from './app.footer.component';
import { AppMainComponent } from './app.main.component';
import { AppMenuitemComponent } from './app.menuitem.component';
import { AppRightmenuComponent } from './app.rightmenu.component';
import { AppSearchComponent } from './app.search.component';
// import { AppTopBarComponent } from './app.topbar.component';

import { TokenInterceptorService } from './core/interceptors/token-interceptor.service';
import { ProgressSpinnerComponent } from './core/progress-spinner/progress-spinner.component';
import { AuthService } from './core/services/auth.service';
import { CustomMessageService } from './core/services/custom-message.service';
import { ProgressSpinnerService } from './core/services/progress-spinner.service';


import { LoginComponent } from './login/login.component';
import { PrimengModule } from './primeng.module';


// primeNG 17
import { AppTopBarComponent } from '../app/app.topbar.component';
import { AppLayoutModule } from './layout/app.layout.module';


registerLocaleData(localeSwedish, 'sv-SE');


@NgModule({ schemas: [CUSTOM_ELEMENTS_SCHEMA],
    declarations: [
        AppComponent,
        LoginComponent,
        AppRightmenuComponent,
        AppMainComponent,
        AppMenuitemComponent,
        AppConfigComponent,
        AppTopBarComponent,
        AppSearchComponent,
        AppFooterComponent,
        ProgressSpinnerComponent,
    ],
    exports: [
        AppCodeModule,
        AppMainComponent,
    ],
    bootstrap: [AppComponent], imports: [AppCodeModule,
        BrowserModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        AppRoutingModule,
        PrimengModule,
        AppLayoutModule], providers: [
        BreadcrumbService,
        HttpClient,
        AuthService,
        AppConfig,
        ProgressSpinnerService,
        CustomMessageService,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptorService,
            multi: true,
        },
        { provide: 'MAX_FILE_SIZE', useValue: 10000000 }
        // { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptorService, multi: true }
        ,
        provideHttpClient(withInterceptorsFromDi())
    ] })

export class AppModule { }
